<template>
    <modal-component 
        :title="$helpers.trans('auth.login')" 
        :open="open" 
        @close="$emit('update:open', false)">

        <form-component 
            name="Login" 
            action="/login" 
            :success-message="$helpers.trans('auth.loginSucceeded')"
            @success="loginComplete($event)"
            :spam-filter="false">
            <div class="form-group">
                <input id="login_email" type="email" required class="form-control" :class="{ 'used': user.email }" name="email" v-model="user.email">
                <label for="login_email" class="form-label">
                    <span class="form-label__content">{{ $helpers.trans('auth.email') }}</span>
                </label>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <input id="login_password" type="password" required class="form-control" :class="{ 'used': user.password }" name="password" v-model="user.password">
                <label for="login_password" class="form-label">
                    <span class="form-label__content">{{ $helpers.trans('auth.password') }}</span>
                </label>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <div class="custom-control custom-checkbox">
                    <input id="rememberUser" type="checkbox" name="remember" class="custom-control-input" v-model="user.remember">
                    <label for="rememberUser" class="custom-control-label">{{ $helpers.trans('auth.rememberUser') }}</label>
                </div>
                <div class="invalid-feedback"></div>
            </div>

            <div slot="submit" slot-scope="slotProps" class="form-group m-0">
                <button type="submit" class="btn btn-secondary--inverted" @click.prevent="slotProps.submit()">
                    <i class="fal fa-btn fa-sign-in"></i> {{ $helpers.trans('auth.login') }}
                </button>

                <a class="btn btn-link text-secondary" href="/password/reset">{{ $helpers.trans('auth.passwordReset') }}</a>
            </div>
        </form-component>
    </modal-component>
</template>
<script>
import ModalComponent from '@app/components/Modal.vue'
import FormComponent from '@app/components/Form.vue'

export default {
    components: {
        ModalComponent,
        FormComponent
    },
    props: ['open'],
    data() {
        return {
            user: {
                email: null,
                password: null,
                remember: false,
            },
        }
    },

    methods: {
        loginComplete(event) {
            window.location = '/de/kundenlogin';
        }
    }
}
</script>
